import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { Vehicle } from '@shared/models/vehicle.model'

@Injectable({
  providedIn: 'root',
})
export class MapListVehiclesService {
  private readonly _vehiclesSource = new BehaviorSubject<Vehicle[]>([])
  readonly vehicles$ = this._vehiclesSource.asObservable()

  getVehicles(): Vehicle[] {
    return this._vehiclesSource.getValue()
  }

  private _setVehicles(vehicles: Vehicle[]): void {
    this._vehiclesSource.next(vehicles)
  }

  setVehicles(vehicles: Vehicle[]): void {
    this._setVehicles(vehicles)
  }
}
